export default __webpack_public_path__ + "static/automatedcertificatesandsecrets-f4f81392c00cbf119874588444fd122a.svg";